<template>
    <div class="wrapper ">
        Calendar !
    </div>
</template>

<script>
    export default {
        name: "Calendar"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Calendar.vue